module.exports = __webpack_public_path__ + "static/media/tapal.d27f2222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/clients/tapal.png
// module id = 273
// module chunks = 0